<template>
    <div class="drop-down-select" v-click-outside-component="closeDropDown">
        <div class="drop-down-select__btn" @click="() => { menuActive = !menuActive }">
            <span>{{title}}</span>
            <i v-if="loading" class="fas fa-sync rotating"></i>
            <template v-else>
                <i v-if="menuActive" class="lnr lnr-chevron-up"></i>
                <i v-else class="lnr lnr-chevron-down"></i>
            </template>
        </div>
        <ul class="drop-down-select__list" v-if="menuActive">
            <li v-for="(e,i) in items" :key="i" @click="selectDropDown(e)">{{e}}</li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            required: true,
            type: String
        },
        items: {
            required: true,
            type: Array
        },
        onSelect: {
            required: true,
            type: Function
        },
        loading: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        menuActive: false
    }),
    methods: {
        closeDropDown() {
            this.menuActive = false
        },
        selectDropDown(e) {
            this.$props.onSelect(e)
            this.closeDropDown()
        }
    }
}
</script>

<style lang="sass" scoped>
@import "styles/global-variables.sass"

.drop-down-select
    position: relative
    width: 150px
    margin: 10px 0 10px auto
    &__btn
        display: inline-block
        vertical-align: top
        height: 34px
        text-align: center
        line-height: 34px
        color: #fff
        font-weight: 500
        font-size: 14px
        background-color: #4771F3
        border: 0
        border-radius: 5px
        cursor: pointer
        padding: 0 10px
    .lnr, .fas
        vertical-align: middle
        margin-left: 2px
    .fas
        font-size: 12px
    &__list
        width: 185px
        padding: 0
        display: inline-block
        position: absolute
        background-color: #fff
        padding: 5px 10px
        border: 1px solid gray
        border-radius: 5px
        left: 0
        top: 25px
        li
            margin: 5px 0
            font-size: 14px
            &:hover
                cursor: pointer
                color: $link-blue-color
</style>